import { ProjectInfo } from "src/components/types";
import React from "react";

export function findClosingBracketIndex(searchString: string, openingBracket: string, closingBracket: string) {
  let openAmt = 0;
  for (let i = 0; i < searchString.length; ++i) {
    let bracketMatchCount = 0;
    for (let j = 0; j < openingBracket.length; j++) {
      if (searchString[i + j] == openingBracket[j]) {
        bracketMatchCount++;
      }
    }
    if (bracketMatchCount === openingBracket.length) {
      openAmt++;
    }

    if (searchString[i] == closingBracket) {
      openAmt--;
      if (openAmt == 0) {
        return i;
      }
    }
  }
  return -1;
}

export function canSeeFeedback(projectData: ProjectInfo) {
  //return false;
  let roles = projectData.roles;
  return (
    localStorage.getItem("user-role")?.includes("admin") ||
    localStorage.getItem("user-role")?.includes("cgestaff") ||
    roles?.mod?.includes(localStorage.getItem("user-name") ?? "") ||
    roles?.designer?.includes(localStorage.getItem("user-name") ?? "")
  );
}

export function canAdminProject(projectData: ProjectInfo) {
  //return false;
  let roles = projectData.roles;
  return (
    localStorage.getItem("user-role")?.includes("admin") ||
    roles?.mod?.includes(localStorage.getItem("user-name") ?? "") ||
    roles?.designer?.includes(localStorage.getItem("user-name") ?? "") ||
    false
  );
}

export function isModKeyDown(event: React.MouseEvent | KeyboardEvent) {
  // the default modifier key for macOS is Cmd (=event.metaKey)
  return event.ctrlKey || event.metaKey;
}
